// update state
const setActionTaskNotifications = (payload) => {
    return {
        type: "ACTIONTASKNOTIFICATION",
        payload
    }
}

export default setActionTaskNotifications;


// WEBPACK FOOTER //
// ./src/actions/setActionTaskNotifications.js